import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from 'styled-components'
import NewsCard from '../components/NewsCard'
import { LinearProgress } from "@mui/material";



function News() {

    const [news, setNews] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.title = "News"
        const fetchNews = async () => {
            setIsLoading(true);
            const response = await axios.get("https://lehumo.co.za/api/news/");
            setNews(response.data);
            setIsLoading(false);
        };

        fetchNews();
    }, []);


    return (
        <>
            <Container>
                <h1>Latest News</h1>
                {!isLoading ? (
                    <Row>

                        <>
                            {news.map(article => {
                                return (
                                    <NewsCard
                                        key={article.id}
                                        headline={article.headline}
                                        story={article.story}
                                        date={article.date}
                                    />
                                );
                            })}
                        </>

                    </Row>

                ) : (
                    <div><LinearProgress style={{ backgroundColor: "var(--primary)" }} /></div>
                )}

            </Container>
        </>
    )
}

export default News

const Container = styled.div`

    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 100px 0;

    h1 {
        text-transform: uppercase;
        text-align: center;
        font-size: 36px;
        padding: 20px 0;
    }

`

const Row = styled.div`
    width: 90%;
    margin: 0  auto;
    padding-top: 20px;
    text-align: center;
    display: grid;
    grid-gap: 20px;
    align-items: center;
    justify-content: space-evenly;
    grid-template-columns: repeat(3, minmax(0,1fr));

    @media (max-width: 821px) {
        grid-template-columns: repeat(1, minmax(0,1fr));

    }
`